var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"1400px"}},[_c('json-view',{attrs:{"data":_vm.dstatus,"rootKey":"view","maxDepth":3,"styles":_vm.defaultStyles}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/pages/instances/status.vue?vue&type=template&id=02fedfbe&
// module id = null
// module chunks = 